import { Sparkle, Instagram, Twitter, Facebook } from "lucide-react"
import { Link } from "react-router"
import { BRAND_NAME, BRAND_TAGLINE } from "../utils/config"

export default function Footer(){

    return (
        <footer className="bg-charcoal text-cream/70">
            <div className="w-[80%] mx-auto py-12 grid sm:grid-cols-3 gap-10">

                <div>
                    <div className="flex items-center gap-2 text-cream mb-3">
                        <Sparkle className="w-5 h-5 text-turmeric" fill="currentColor" />
                        <span className="font-display text-xl font-semibold">{BRAND_NAME}</span>
                    </div>
                    <p className="text-sm max-w-xs">{BRAND_TAGLINE}</p>
                </div>

                <div>
                    <h3 className="text-cream font-medium mb-3 text-sm uppercase tracking-wide">Explore</h3>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/" className="hover:text-turmeric transition">Home</Link></li>
                        <li><Link to="/restaurant" className="hover:text-turmeric transition">Restaurants</Link></li>
                        <li><Link to="/signin" className="hover:text-turmeric transition">Sign in</Link></li>
                    </ul>
                </div>

                <div>
                    <h3 className="text-cream font-medium mb-3 text-sm uppercase tracking-wide">Connect</h3>
                    <div className="flex gap-4">
                        <a href="#" className="hover:text-turmeric transition"><Instagram className="w-5 h-5" /></a>
                        <a href="#" className="hover:text-turmeric transition"><Twitter className="w-5 h-5" /></a>
                        <a href="#" className="hover:text-turmeric transition"><Facebook className="w-5 h-5" /></a>
                    </div>
                </div>

            </div>

            <div className="border-t border-cream/10 py-6">
                <p className="w-[80%] mx-auto text-xs text-cream/40 font-mono">
                    © {new Date().getFullYear()} {BRAND_NAME}. Built as a demo project for PBEL IBM Virtual Internship by Ankit Gupta.
                </p>
            </div>
        </footer>
    )
}
